import { ProceduresFilters } from '@/components/procedures/proceduresFilters';
import { ProceduresList } from '@/components/procedures/proceduresList';
import { ProceduresContext } from '@/context/proceduresContext';
import { useFilters } from '@/hooks/useFilters';
import { usePermission } from '@/hooks/usePermission';
import { ProcedureFilters } from '@/types/procedures/filters';
import { routes } from '@/types/routes';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_app/procedures/')({
  component: RouteComponent,
});

const DEFAULT_FILTERS: ProcedureFilters = {
  subjectHumanReadableId: null,
  procedureDate: null,
  procedureStatus: '*',
};

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { setPage, setActiveFilters } = useContext(ProceduresContext);

  const resetPage = () => {
    void setPage(1);
  };

  const filters = useFilters(DEFAULT_FILTERS, { onFiltersChanged: resetPage });

  useEffect(() => {
    setActiveFilters(filters.serializedFilters);
  }, [ filters.serializedFilters ]);

  const hasPermissions = usePermission('procedure.canRead', { allowAnySite: true });
  if (!hasPermissions) {
    void navigate({ to: routes.patients, replace: true });
    return null;
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="flex justify-between items-center mb-space-2xl">
        <h1 className="text-3xl font-semibold">{ t('title', { ns: 'procedures' }) }</h1>
      </div>
      <div className="flex flex-col gap-6">
        <ProceduresFilters filters={ filters } />
        <ProceduresList />
      </div>
    </div>
  );
}
